import React from 'react'

export function BlankLink (props) {
	const { children, href } = props
	const options = { target: '_blank', rel: 'noopener noreferrer' }
  return href ? <a {...options} {...props}>{children}</a> : null
}
